export default {
  handler: 'relativeUrl',
  data: () => '/bet_builder/fixtures',
};
